import { t } from "@/i18n-js/instance";
import { isRefundedOrPartialRefunded } from "@circle-react/helpers/communityMemberChargeHelpers";
import type { CommunityMemberCharge } from "@circle-react/types/CommunityMemberCharge";
import { PaywallChargeBadge } from "@circle-react-shared/Paywalls/PaywallChargeBadge";
import { PropertyLine } from "./PropertyLine";

const localeStringRoot =
  "settings.paywalls_admin_dashboard.charges.charge_details_modal";

export const ChargeStatusProperty = ({
  charge,
}: {
  charge: CommunityMemberCharge;
}) => {
  if (!isRefundedOrPartialRefunded(charge)) {
    return null;
  }

  return (
    <PropertyLine title={t(`${localeStringRoot}.details_labels.status`)}>
      <PaywallChargeBadge status={charge?.display_status} />
    </PropertyLine>
  );
};
